import * as C from "@components";
import React from "react";
import { ProductCustomizationsSection } from "../ProductCustomizationsSection/ProductCustomizationsSection";

interface ProductXLCustomizationsSectionProps extends Omit<React.ComponentProps<typeof ProductCustomizationsSection>, "height" | "items">
{
    imageDirectory: string;
}

export const ProductXLCustomizationsSection = ({ imageDirectory, ...props }: ProductXLCustomizationsSectionProps): React.ReactComponentElement<typeof ProductCustomizationsSection, ProductXLCustomizationsSectionProps> =>
    <ProductCustomizationsSection
        {...props}
        height={{ all: C.Height.H240, ipad: C.Height.H320, desktop: C.Height.H320 }}
        items={[
            { src: `${imageDirectory}customizations.1.png`, alt: "Customizations #1", width: 49, height: 250, bgColor: "#57BDFF" },
            { src: `${imageDirectory}customizations.2.png`, alt: "Customizations #2", width: 64, height: 250, bgColor: "#C5A98E" },
            { src: `${imageDirectory}customizations.3.png`, alt: "Customizations #3", width: 50, height: 250, bgColor: "#559055" },
            { src: `${imageDirectory}customizations.4.png`, alt: "Customizations #4", width: 52, height: 250, bgColor: "#202020" },
            { src: `${imageDirectory}customizations.5.png`, alt: "Customizations #5", width: 63, height: 250, bgColor: "#8D44DD" },
        ]}
    />;
